import customAxios from "./axiosConfig";

const CostTypeGroupService = {
  list: function (params) {
    var api_url = window.Urls['cost-type-group-list']();
    return customAxios.get(api_url, { params: params });
  },
};

export default CostTypeGroupService;